import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import FormBuilder from "../components/FormBuilder/FormBuilder";
import {
  Button,
  Box,
  Grid,
  Link,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
  Alert,
  Snackbar,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { ACTION } from "../utils/commonConstant";
import ContractPreviewPopup from "../ModelPopup/ContractPreviewPopup";
import { fetchFromWebApi } from "../utils/fetchFromWebApi";
import MenuIcon from "@mui/icons-material/Menu";

const CreateTemplateLibrary = () => {
  const [elements, setElements] = useState([]);
  const [openPreview, setOpenPreview] = useState(false);
  const { clientId, action, templateId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleOpenPreview = () => {
    if (elements.length === 0) {
      toast.error("Please add elements in form.");
      return;
    }
    setOpenPreview(true);
  };
  const handleModelDialogClose = () => {
    setEditDialogOpen(false);
  };
  const handleClosePreview = () => setOpenPreview(false);
  const [templateLibraryId, setTemplateLibraryId] = useState(
    templateId ?? null
  );
  const [hhtemplate, setHHTemplate] = useState({
    templatename: "",
  });
  const [errors, setErrors] = useState({
    templatename: "",
  });
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Function to handle save action
  const handleSave = async () => {
    if (elements.length === 0) {
      toast.error("Please add elements in form.");
      return;
    }
    setIsSaving(false);
    setEditDialogOpen(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  const fetchEditForm = async () => {
    try {
      const res = await fetchFromWebApi(
        `HHTemplateLibrary/GetHHTemplateLibraryById?Id=${templateId}`,
        {
          method: "GET"
        }
      );
      // Handle response
      if (res?.ok) {
        let json = await res.json();
        console.log(json, "jsondata");
        setElements(json.MetaData);
        setTemplateLibraryId(json.Id);
        setHHTemplate((prevHHContract) => ({
          ...prevHHContract,
          templatename: json.Name,
        }));
        setOpenSnackbar(true);
        console.log("Form saved successfully!");
      } else {
        // Handle error response
        console.error("Failed to save form:", await res.text());
      }
    } catch (error) {
      // Handle network errors
      console.error("Error while saving form:", error);
    }
  };
  const handleRedirectBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (ACTION.CREATE === action) {
      setTemplateLibraryId(null);
    } else if (ACTION.EDIT === action) {
      fetchEditForm();
    }
  }, []);

  const handleInputChange = (event) => {
    console.log(event.target);
    const { name, value } = event.target;
    setHHTemplate({ ...hhtemplate, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  const handleEditSave = async () => {
    if (isSaving) return;
    let formValid = true;
    const newErrors = { ...errors };
    // Basic validation
    if (!hhtemplate.templatename) {
      newErrors.templatename = "Template Name is required";
      formValid = false;
    }
    if (!formValid) {
      setErrors(newErrors);
      return;
    }
    setIsSaving(true);
    setEditDialogOpen(false);
    try {
      const res = await fetchFromWebApi(
        `HHTemplateLibrary/Create`,
        {
          method: "POST",
          body: JSON.stringify({
            name: hhtemplate.templatename,
            metaData: elements,
            id: templateLibraryId,
          }),
        }
      );

      if (res?.ok) {
        toast.success("Form saved successfully.");
      } else {
        toast.error("Failed to save form:", await res.text());
      }
    } catch (error) {
      toast.error("Error while saving form:", error);
    }
  };
  return (
    <Box sx={{ padding: 2 }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          left: 0,
          width: "100%",
          backgroundColor: "white",
          zIndex: 1000,
          boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <Snackbar
          open={openSnackbar}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {`This is  Edit for Template Name is ${hhtemplate.templatename}`}
          </Alert>
        </Snackbar>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{ marginBottom: 3 }}
        >
          <Grid item xs={12} sm="auto" display="flex" justifyContent="center">
            <Link href={`/${clientId}`}>
              <img
                src="https://portal.hardhats.co.uk/img/Hardhats-Logo.png"
                alt="HardHats Logo"
                style={{ width: "80px", marginRight: "20px" }}
              />
            </Link>
          </Grid>
          <Grid item xs={12} sm="auto">
            <h2 style={{ textAlign: "center" }}>Template Library</h2>
          </Grid>
        </Grid>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <IconButton
                  onClick={() => setIsCollapsed(!isCollapsed)} // Toggle collapse state
                  sx={{ marginBottom: 0 }}
                >
                  <MenuIcon color="primary" />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
          {/* Right Side Buttons */}
          <Grid item>
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenPreview}
                >
                  Preview Form
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                >
                  {action === ACTION.EDIT ? "Update" : "Save"}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleRedirectBack}
                >
                  Back
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <FormBuilder
        submitForm={handleEditSave}
        elements={elements}
        setElements={setElements}
        isTemplate={true}
        isCollapsed={isCollapsed}
      />

      <ContractPreviewPopup
        open={openPreview}
        onClose={handleClosePreview}
        elements={elements}
        clientId={clientId}
      />
      {/* model popup for contract version */}
      <Dialog
        open={editDialogOpen}
        onClose={handleModelDialogClose}
        maxWidth="md"
        fullWidth={fullScreen}
      >
        <DialogTitle>
          {ACTION.CREATE === action
            ? "Create Template Library"
            : "Edit Template Library"}
        </DialogTitle>
        <DialogContent sx={{ width: fullScreen ? "100%" : "600px" }}>
          <TextField
            margin="dense"
            label="Template Name"
            variant="outlined"
            name="templatename"
            value={hhtemplate.templatename}
            type="text"
            fullWidth
            onChange={handleInputChange}
            error={!!errors.templatename}
            helperText={errors.templatename}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModelDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleEditSave} color="primary" disabled={isSaving}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CreateTemplateLibrary;
